// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2SQsL","header":"ClearentDisclaimer_header__1yi1-","inner":"ClearentDisclaimer_inner__rx4G6"};